import { Component, computed, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { INews } from '@core/interfaces/news.interface';
import { NewsComponent } from '@shared/components/news/news.component';
import { SideDialogComponent } from '@shared/components/side-dialog/side-dialog.component';
import { TextClampTooltipDirective } from '@shared/directives/text-clamp-tooltip.directive';
import { INewsDialogData } from './news-dialog.interface';

@Component({
  imports: [SideDialogComponent, NewsComponent, MatTooltipModule, TextClampTooltipDirective],
  selector: 'app-news-dialog',
  templateUrl: './news-dialog.component.html',
})
export class NewsDialogComponent {
  public readonly news = computed<INews>(() => this.data.news);

  public readonly data = inject<INewsDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<NewsDialogComponent>);

  public onCloseClick(): void {
    this.dialogRef.close();
  }
}
